export const selectFlippers = state => state.flippers;

export const selectStripeRetailEnabled = state => state.flippers.stripeRetail;

const campaignResultsV2 = state => state.flippers.campaignResultsV2;
export default campaignResultsV2;
